import { useEffect, useRef } from "react";

export const useClickOutside = (setIsClose: any, addRef?: HTMLElement[]) => {
    const rootEl: any = useRef(null);

    useEffect(() => {
        const onClick = (e: any) => {
            if(addRef?.length) {
                //console.log(addRef);
                let check = false;
                addRef.map(element => {
                    if(element.contains(e.target)) {
                        check = true;
                    }
                })
                return rootEl.current?.contains(e.target) || check || setIsClose(false)
            } else return rootEl.current?.contains(e.target) || setIsClose(false)
        };
        const onTab = (e: any) => {
            if(e.keyCode === 9)
                return rootEl.current?.contains(e.target) || setIsClose(false)
        }
        document.addEventListener('click', onClick);
        document.addEventListener('keyup', onTab);
        return () => {
            document.removeEventListener('click', onClick)
            document.removeEventListener('keyup', onTab)
        };
    }, [addRef]);

    return {rootEl}
}